export class MediaQueryObserver {
    /** @internal */
    constructor(comp) {
        this._$observer = null;
        this._$comp = comp;
    }
    observe(descriptor, listener) {
        var _a, _b;
        if (this._$observer)
            this._$observer.disconnect();
        this._$observer =
            ((_b = (_a = this._$comp._$.getBackendContext()) === null || _a === void 0 ? void 0 : _a.createMediaQueryObserver) === null || _b === void 0 ? void 0 : _b.call(_a, descriptor, listener)) || null;
    }
    disconnect() {
        if (this._$observer)
            this._$observer.disconnect();
        this._$observer = null;
    }
}
//# sourceMappingURL=media_query.js.map